/*
 *
 * OperationDetailModal
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 06-Dec-2024
 */

import React from 'react'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  operation: (operation) => (
    <PortalMessage id='t.app.orders.operation.detail.subtitle' defaultMessage='Operation ID' values={{ operation }} />
  )
}

export default formattedMessage
